import React from 'react'
import MainTitle from '../../../components/ui/MainTitle'
import InstructionsForm from '../../../components/store/products/form/InstructionForm'

export default function AddProductInstructions() {
  return (
    <div className='container p-6 h-[100vh] overflow-auto'>
        <div className="mb-14">
            <MainTitle title="add_new_product"/>
        </div>
        <div>
            <InstructionsForm/>
        </div>
    </div>
  )
}
